import { render, staticRenderFns } from "./HrHireRegistSchool.vue?vue&type=template&id=7dc6cb1d&scoped=true&"
import script from "./HrHireRegistSchool.vue?vue&type=script&lang=js&"
export * from "./HrHireRegistSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc6cb1d",
  null
  
)

export default component.exports